module.exports = __webpack_public_path__ + "img/saum_weiss_candy.94d1b08f.jpg";